<template>
    <v-dialog v-model="dialog" scrollable max-width="800">
        <template v-slot:activator="{ props }">
            <v-btn
                icon
                v-bind="props"
                color="secondary"
                class="text-capitalize text-typography3"
            >
                <v-icon size="x-large" color="secondary">
                    mdi-information-outline
                </v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title class="mb-4">
                <v-tabs grow v-model="activeTab" color="secondary">
                    <v-tab v-for="tab of tabs" :key="tab.id">
                        {{ tab.name }}
                    </v-tab>
                </v-tabs>
            </v-card-title>
            <v-card-text style="height: 500px">
                <span v-show="activeTab === 0">
                    <span v-if="library.libraryVersions">
                        <p
                            class="
                                text-title-large
                                font-weight-medium
                                text-high-emphasis
                            "
                        >
                            Description
                        </p>
                        <p class="text-high-emphasis">
                            {{ library.libraryVersions[0].description }}
                        </p>

                        <p
                            class="
                                text-title-large
                                font-weight-medium
                                text-high-emphasis
                            "
                            v-if="library.libraryVersions"
                        >
                            Updated at:
                            {{
                                new Date(
                                    library.libraryVersions[0].date
                                ).toDateString()
                            }}
                        </p>

                        <p
                            class="
                                text-title-large
                                font-weight-medium
                                text-high-emphasis
                            "
                            v-if="library.allVersions"
                        >
                            Created at:
                            {{
                                new Date(
                                    library.allVersions[
                                        library.allVersions.length - 1
                                    ].date
                                ).toDateString()
                            }}
                        </p>
                    </span>

                    <p
                        class="
                            text-title-large
                            font-weight-medium
                            text-high-emphasis
                        "
                    >
                        Created By: {{ library.user.first }}
                        {{ library.user.last }}
                    </p>
                </span>

                <span v-show="activeTab === 1">
                    <p class="text-high-emphasis">
                        Select Version to browse it.
                    </p>
                    <v-autocomplete
                        :items="library.allVersions"
                        item-title="version"
                        return-object
                        color="secondary"
                        item-color="secondary"
                        variant="solo"
                        rounded
                    >
                        <template v-slot:item="{ item, props }">
                            <v-list-item
                                v-bind="props"
                                @click="goToVersion(item.raw)"
                            >
                                <v-list-item-title>{{
                                    item.raw.version
                                }}</v-list-item-title>
                                <template v-slot:append>{{
                                    new Date(item.raw.date).toDateString()
                                }}</template>
                            </v-list-item>
                        </template>
                    </v-autocomplete>
                </span>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="secondary"
                    rounded
                    class="text-capitalize text-typography3"
                    @click=";(dialog = false), setTab('info')"
                >
                    Close
                </v-btn>
                <v-btn
                    rounded
                    color="secondary"
                    class="text-capitalize text-typography3"
                    :to="{
                        name: 'libraryBrowser',
                        params: { libraryId: library.libraryId },
                    }"
                >
                    Explore Library
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'

const props = defineProps({
    library: { type: Object, required: true },
})

const router = useRouter()
const dialog = ref(false)
const activeTab = ref(0)
const tabs = [
    { id: 0, name: 'Information' },
    { id: 1, name: 'Version History' },
]

function setTab(tabName) {
    activeTab.value = tabs.findIndex(
        (t) => t.name.toLowerCase() === tabName.toLowerCase()
    )
}

function goToVersion(version) {
    router.push({
        name: 'libraryBrowser',
        params: { libraryId: props.library.libraryId },
        query: { path: `v${version.version}` },
    })
    dialog.value = false
}
</script>
